import { inject } from 'vue';

export enum INotificationStatus {
  Success = 'success',
  Warning = 'warning',
  Error = 'error'
}

export interface INotification {
  description: string;
  status: INotificationStatus;
}

interface IShowNotificationFunction {
  (notification: INotification): void;
}

export interface IUseNotificationResponse {
  show: IShowNotificationFunction;
  hide: () => void;
}

export function useNotification(): IUseNotificationResponse {
  // inject
  const $notification: Ref<any> | undefined = inject('$notification');

  // methods
  const show = (notification: INotification): void => {
    $notification?.value.show(notification);
  };

  const hide = (): void => {
    $notification?.value.hide();
  };

  return {
    show,
    hide
  };
}
